module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sWeb",
    staticClass: "s-web"
  }, [_c('div', {
    staticClass: "darg-wrap"
  }, [_c('drag', [_c('div', {
    staticClass: "work",
    attrs: {
      "slot": "uLeft"
    },
    on: {
      "click": _vm.chooseScreenLeft
    },
    slot: "uLeft"
  }, [_c('k-header', {
    class: {
      negScreen: !_vm.negScreen
    },
    attrs: {
      "headerData": _vm.headerTeacher
    }
  }), _vm._v(" "), _c('section', {
    ref: "tWorkspace",
    staticClass: "workspace"
  }, [_c('section', {
    staticClass: "editor"
  }, [_c('textarea', {
    ref: "teacherEditor"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "dLeft"
    },
    on: {
      "click": _vm.chooseScreenLeft
    },
    slot: "dLeft"
  }, [_c('section', {
    ref: "tItermWrap",
    class: ['iterm-wrap', {
      negScreen: !_vm.negScreen
    }]
  }, [_c('div', {
    staticClass: "web-menu"
  }, [_c('span', [_vm._v("结果展示")])]), _vm._v(" "), _c('iframe', {
    ref: "teacher",
    staticClass: "resultIframe",
    attrs: {
      "frameBorder": "0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "work bdl",
    attrs: {
      "slot": "uRight"
    },
    on: {
      "click": _vm.chooseScreenRight
    },
    slot: "uRight"
  }, [_c('k-header', {
    class: {
      negScreen: _vm.negScreen
    },
    attrs: {
      "headerData": _vm.headerStudent
    }
  }, [_c('span', {
    staticClass: "live-btn",
    on: {
      "click": _vm.issueQA
    }
  }, [_vm._v("提问")]), _vm._v(" "), _c('span', {
    staticClass: "live-btn t-clear",
    on: {
      "click": _vm.clearCode
    }
  }, [_vm._v("清除代码")]), _vm._v(" "), _c('span', {
    staticClass: "live-btn t-clear",
    on: {
      "click": _vm.exportCode
    }
  }, [_vm._v("导出代码")])]), _vm._v(" "), _c('div', {
    ref: "sWorkspace",
    staticClass: "workspace"
  }, [_c('section', {
    staticClass: "editor"
  }, [_c('textarea', {
    ref: "studentEditor"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "work bdl",
    attrs: {
      "slot": "dRight"
    },
    on: {
      "click": _vm.chooseScreenRight
    },
    slot: "dRight"
  }, [_c('browser', {
    class: {
      negScreen: _vm.negScreen
    },
    attrs: {
      "options": _vm.browserOption,
      "code": _vm.editorContent
    },
    on: {
      "insertCodeSnippet": _vm.insertData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countdown),
      expression: "countdown"
    }],
    ref: "countdown",
    staticClass: "countdown"
  }, [_c('h1', [_vm._v(_vm._s(_vm.count))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae3b51c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/web/web_student.vue
// module id = 524
// module chunks = 1